/*
 *   Copyright (c) 2021 vlinder Labs Private Limited
 *   All rights reserved.
 *   This software is proprietary of Vlinder Labs Pvt. Ltd and can not be distributed / used for any purpose outside of Vlinder Labs Pvt. Ltd without explicit written consent from the copyright owner.
 */

import {
  IAgentPlugin,
  IPluginMethodMap,
} from '@vlinder-web/plugin-agent-service-react';
import { appCardHoldersDetailConfig } from '../../config/appCardList.config';
import { GET_HOLDER_POLICY_LIST } from '../../api/graphql';
import { Graphql } from '@/common/graphql';
import { apiConfig } from '@/config/apiConfig';
import { AppNavigatorService } from '@/AppNavigator/services';
import { vappContainer } from '@/application';

import { useUserId } from '@pages/HoldersDetailPage/provider';
import { toHeaderCase } from 'js-convert-case';
import moment from 'moment';
export interface IappCardListPluginMethods extends IPluginMethodMap {
  getappCardList(args?: any): any;
}

const loginSrv = () => {
  return vappContainer.get<AppNavigatorService>(
    AppNavigatorService.displayName
  );
};

export class appCardListPlugin implements IAgentPlugin {
  readonly methods: IappCardListPluginMethods;

  constructor() {
    this.methods = {
      getappCardList: this.getappCardList.bind(this),
    };
  }

  async getappCardList(args?: any) {
    return await this.cardList(args);
  }

  private async cardList(args: any) {
    const { userId } = useUserId();
    try {
      let gql = Graphql.withBaseUrl(apiConfig.gql.url);
      // const token = getToken();
      const token = loginSrv()?.getToken();
      if (token) {
        gql = gql.withHeaders({
          authentication: token,
        });
      }
      const client = gql.getClient();
      const res = await client.query(GET_HOLDER_POLICY_LIST, {
        getListOfPoliciesInput2: {
          skip: args?.offset ?? 0,
          limit: args?.size ?? 10,
          where: [
            {
              column: 'purchasedBy',
              op: 'Equal',
              value: [userId],
            },
          ],
          order: [
            {
              column: 'purchasedAt',
              direction: 'DESC',
            },
          ],
        },
      });
      if (res?.data?.getListOfPolicies) {
        let _templateData = this.formatTemplateList(
          res?.data?.getListOfPolicies?.data
        );
        return {
          appCardList: _templateData,
          isEmpty: res?.data?.getListOfPolicies?.data?.length <= 0,
          // studentGroup: holderGroups,
          activePage: res?.data?.getListOfPolicies?.currentPage,
          pageSize: res?.data?.getListOfPolicies?.pageSize,
          totalCount: res?.data?.getListOfPolicies?.totalCount,
          totalPages: res?.data?.getListOfPolicies?.totalPages,
        };
      }
    } catch (err: any) {
      return {
        isEmpty: true,
      };
    }
  }
  private formatTemplateList(data: any) {
    let _rowData: any =
      Array.isArray(data) &&
      data.map((item: any) => {
        return {
          rowData: item,
          id: item?.policyNumber,
          policyId: item?.policyId,
          vuid: item?.purchasedBy?.vuid,
          appCardImage: item?.logo ?? appCardHoldersDetailConfig?.icon,
          appCardTitle: item?.productDefination
            ? `Policy Option ${toHeaderCase(item?.productDefination)}`
            : '',
          appCardDescription: item?.createdAt
            ? moment(item?.createdAt).format('DD/MM/YYYY')
            : '',
          appCardList: [
            {
              name: 'Policy No',
              value: item?.policyNumber,
            },
          ],
        };
      });

    return _rowData;
  }
}
